/* bo-earplugs-preventa.js — PDP Tapones (preventa y venta) · v3 rediseño: qty+labels, carrusel con flechas/caption, sticky flotante, COD */
(function () {
  'use strict';
  var root = document.getElementById('bo-epw');
  if (!root) return;

  var variantId = parseInt(root.getAttribute('data-variant'), 10) || 0;
  var unitPrice = parseInt(root.getAttribute('data-price'), 10) || 0; /* centavos */
  var compareAt = parseInt(root.getAttribute('data-compare'), 10) || 0;
  var title = root.getAttribute('data-title') || 'Tapones para Dormir';
  var image = root.getAttribute('data-img') || '';
  var packNote = root.getAttribute('data-packnote') || '';
  var label1 = root.getAttribute('data-cta1') || '';
  var label2 = root.getAttribute('data-cta2') || '';
  var save2 = parseInt(root.getAttribute('data-save2'), 10) || 0; /* Bs, ahorro por cada 2 pares (= worker EARPLUGS_PAIR_SAVING) */
  var moneyFmt = (root.getAttribute('data-money') || '{{amount}}').replace(/<[^>]+>/g, '');
  var qty = 1;

  /* Cada 2 pares ahorran save2 (24-sep-2026: 2 = 400, 4 = 800). El worker cobra lo mismo. */
  function savingBs(q) { return Math.floor(q / 2) * save2; }
  function savingsTable() {
    var t = {};
    for (var q = 1; q <= 6; q++) t[q] = savingBs(q);
    return t;
  }

  function money(cents) {
    var n = cents / 100;
    var noDec = /no_decimals/.test(moneyFmt);
    var s = noDec ? String(Math.round(n)) : n.toFixed(2);
    return moneyFmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s);
  }

  /* ---------- Cantidad: totales del sticky + label de los CTA ---------- */
  function renderQty() {
    root.querySelectorAll('[data-epw-total-now]').forEach(function (el) { el.textContent = money(unitPrice * qty - savingBs(qty) * 100); });
    root.querySelectorAll('[data-epw-total-was]').forEach(function (el) { el.textContent = compareAt ? money(compareAt * qty) : ''; });
    if (label1 && label2) {
      root.querySelectorAll('[data-epw-cta-label]').forEach(function (el) { el.textContent = qty === 2 ? label2 : label1; });
    }
  }
  root.querySelectorAll('[data-epw-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-epw-qty]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      qty = parseInt(btn.getAttribute('data-epw-qty'), 10) || 1;
      renderQty();
    });
  });

  /* ---------- COD ---------- */
  function openCod() {
    if (!variantId) return;
    document.dispatchEvent(new CustomEvent('bo:open-cod', { detail: {
      variantId: variantId,
      qty: qty,
      unitPrice: unitPrice,
      offerId: 'earplugs-pdp',
      saving: savingBs(qty),
      savingsByQty: savingsTable(),
      title: title,
      image: image,
      moneyFormat: moneyFmt,
      nudgeUnit: 'pares',
      packNote: packNote
    } }));
  }
  root.querySelectorAll('[data-epw-cta]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openCod(); });
  });

  /* ---------- Carrusel: flechas + dots + caption ---------- */
  var carousel = root.querySelector('[data-epw-carousel]');
  if (carousel) {
    var slides = [].slice.call(carousel.querySelectorAll('.bo-epw__slide'));
    var dotsWrap = root.querySelector('[data-epw-dots]');
    var capEl = root.querySelector('[data-epw-caption]');
    var current = 0;
    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bo-epw__dot';
        b.setAttribute('aria-label', 'Ir a la foto ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }
    var paint = function () {
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === current); });
      if (capEl && slides[current]) capEl.textContent = slides[current].getAttribute('data-caption') || '';
    };
    var go = function (i) {
      var n = Math.max(0, Math.min(slides.length - 1, i));
      carousel.scrollTo({ left: n * carousel.clientWidth, behavior: 'smooth' });
      current = n;
      paint();
    };
    var prev = root.querySelector('[data-epw-prev]');
    var next = root.querySelector('[data-epw-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    carousel.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        var i = Math.round(carousel.scrollLeft / carousel.clientWidth);
        if (i !== current && i >= 0 && i < slides.length) { current = i; paint(); }
      });
    }, { passive: true });
    paint();
  }

  /* ---------- Sticky flotante: aparece pasado el hero ---------- */
  var sticky = root.querySelector('[data-epw-sticky]');
  var hero = root.querySelector('.bo-epw__hero');
  if (sticky && hero) {
    var on = false;
    var check = function () {
      var next = hero.getBoundingClientRect().bottom < 90;
      if (next !== on) { on = next; sticky.hidden = !on; }
    };
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();
  }

  renderQty();
})();

/* Video de galería: asegurar autoplay (iOS low-power / visibilidad) */
(function () {
  var vids = document.querySelectorAll('.bo-epw__slide--video video');
  if (!vids.length) return;
  var kick = function () { vids.forEach(function (v) { v.muted = true; if (v.paused) v.play().catch(function () {}); }); };
  kick();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });
})();
